import { Component, OnInit, NgZone, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlPosition, MapTypeControlOptions, MapsAPILoader, MouseEvent } from '@agm/core';
import { Observable } from 'rxjs';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
// import { loadStaticMap } from '../../../utils/utils.common';
import { DispatchCenterService } from '../../../service/dispatch-center-service/dispatch-center-service';
import { LatLngLiteral } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { LevelOfServiceService } from '../../../service/level-of-service/level-of-service.service';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { PayorService } from 'src/app/service/payor/payor.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  @Input() tripId: any
  @Input() openFrom?: any
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;

  tripDetails = null;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact;
  trackinURL;
  payorList:any;
  prePayorsList: any = {};
  isAllowAuthorizationNumber = false;

  constructor(
    private payorService: PayorService,
    private authService: AuthService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService
  ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.jobId = this.tripId;
    this.getPayorList();
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
           if (this.user.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.allowAuthorizationNumber;
          } 
          else if (this.user.cooperate && this.user.cooperate.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.cooperate.allowAuthorizationNumber;
          }
          this.getCompletedTripDetail();
        }
      });
  }

  twodigit(val) {
    return parseFloat(Number(Math.round(parseFloat(val)) + 'e-0').toFixed(2));
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;
    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  sendTrackingSMS() {
    if (!this.contact) return;
    this.tripDetails.contactNumber = this.contact;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
    }
    this.assignTripService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  async getCompletedTripDetail() {
    try {
      const data = await this.dispatchCenterService.getTripDetail(this.jobId).toPromise();
  
      if (data) {
        this.tripDetails = data;
  
        if (data.priorityClient) {
          this.contact = data.priorityClient.contactNumber;
        }
  
        this.tripAssistance = {
          displayName: this.tripDetails.priorityClient.displayName,
          contactNumber: this.tripDetails.priorityClient.contactNumber
        };
  
        if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {
          const trackInfo = this.tripDetails.job.trackInfoJob;
  
          if (trackInfo.jobAccepted) {
            this.jobAcceptedUrl = await this.loadStaticMap(trackInfo.jobAccepted.coords[1], trackInfo.jobAccepted.coords[0]);
          }
  
          if (trackInfo.jobArrived) {
            this.jobOnSceneUrl = await this.loadStaticMap(trackInfo.jobArrived.coords[1], trackInfo.jobArrived.coords[0]);
          }
  
          if (trackInfo.jobStarted) {
            this.jobStartedUrl = await this.loadStaticMap(trackInfo.jobStarted.coords[1], trackInfo.jobStarted.coords[0]);
          }
  
          if (trackInfo.jobCompleted) {
            this.jobEndedUrl = await this.loadStaticMap(trackInfo.jobCompleted.coords[1], trackInfo.jobCompleted.coords[0]);
          }
  
          if (trackInfo.jobFinished) {
            this.jobFinishedUrl = await this.loadStaticMap(trackInfo.jobFinished.coords[1], trackInfo.jobFinished.coords[0]);
          }
  
          if (trackInfo.jobCancelled) {
            this.jobCancelledUrl = await this.loadStaticMap(trackInfo.jobCancelled.coords[1], trackInfo.jobCancelled.coords[0]);
          }
        }
  
        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
  
        this.getConfigurations();
      }
    } catch (error) {
      console.error('Error fetching trip details:', error);
    }
  }
  



  getConfigurations() {
    this.assignTripService
      .getConfigurations({ status: 'active' })
      .subscribe(data => {
        if (data) {
          if (data.levelofservices && data.levelofservices.length) {
            this.tripDetails.los = data.levelofservices.find((item) => item._id === this.tripDetails.los);
            this.tripDetails.los = this.tripDetails.los ? this.tripDetails.los.title : 'N/A';
          }
          if (data.spacetypes && data.spacetypes.length) {
            this.tripDetails.spaceType = data.spacetypes.find((item) => item._id === this.tripDetails.spaceType);
            this.tripDetails.spaceType = this.tripDetails.spaceType ? this.tripDetails.spaceType.title : 'N/A';
          }

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }
  loadStaticMap = async (lat: number, lng: number): Promise<string> => {
    try {
      const res = await this.authService.getGoogleKeys().toPromise();
      let mapKey = '';
  
      if (res && res.key) {
        console.log('Load static map API key:');
        mapKey = res.key;
      } else {
        console.error('Error loading static map API key');
      }
  
      const url = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=18&size=500x500&maptype=satellite&markers=color:red|${lat},${lng}&key=${mapKey}`;
      return url;
  
    } catch (error) {
      console.error('Error fetching Google Map key:', error);
      return '';
    }
  }
  

  getJobStatus(status) {
    let tripStatus = status;

    if (status === 'pending') {
      tripStatus = 'Unassigned';
    } else if (status === 'arrived') {
      tripStatus = 'On Scene';
    } else if (status === 'started') {
      tripStatus = 'Member Onboard';
    } else if (status === 'onway') {
      tripStatus = 'In Route';
    }

    return tripStatus
  }

   getPayorList() {
    const param = {
      status: 'active'
    };
    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
            this.prePayorsList = this.payorList.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  ngOnDestroy(): void {
  }

}
